import {NightTimeAddress} from "./NightTimeAddress";

export class Vehicle {
  public modelRangeYearCd: number;
  public itemDescription: string;
  public vehicleRegistrationNo: string;
  public vinNumber: string;
  public nightTimeAddress: NightTimeAddress = new NightTimeAddress();
}
